import React from "react";
import { useAppTranslation } from "../../../../../../../../../i18n/useAppTranslation";
import { Button } from "../../../../../../../../../shared/Button/Button";
import { useContext } from "../../../../../context";
import { CircularProgress } from "../../../../../../../../../shared/CircularProgress/CircularProgress";
import { useSubmit } from "../../../../../hooks/useSubmit";

export const Save = () => {
  const { tSettings: t } = useAppTranslation.Settings({
    keyPrefix: "survey",
  });

  const { title, blocks, isError, blockErrors, blockListRef } = useContext();
  const submit = useSubmit({ blockErrors, blockListRef });

  const handleSubmit = () => {
    submit.initiate({
      title: title.value,
      questions: blocks.unwrap(),
    });
  };

  return (
    <Button
      size="small"
      onClick={handleSubmit}
      isDisabled={submit.isLoading || isError}
      leftAdornment={
        submit.isLoading ? (
          <CircularProgress size="small" color="white" />
        ) : undefined
      }
    >
      {t("action.save")}
    </Button>
  );
};
